import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { coolGrey2 } from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing12,
  spacing16,
} from 'approot/shared/styles/spacing.style';
import { skeletonState } from 'approot/shared/styles/transitions.style';

const baseSkeleton = css`
  background-color: ${coolGrey2};
  border-radius: ${rem(borderRadius8)};
`;

export const ListItem = styled.div`
  display: flex;
  padding: ${rem(spacing8)} ${rem(spacing16)};
`;

export const ListItemContent = styled.div`
  flex-grow: 1;
`;

export const ListItemImage = styled.div`
  ${baseSkeleton}
  ${skeletonState}
  flex-shrink: 0;
  height: ${rem(48)};
  width: ${rem(48)};
  margin-right: ${rem(spacing12)};
`;

type ListItemTextProps = {
  $isSmall?: boolean;
  $marginBottom?: number;
};
export const ListItemText = styled.div<ListItemTextProps>`
  ${baseSkeleton}
  ${skeletonState}

  height: ${rem(20)};
  margin-bottom: ${({ $marginBottom = spacing8 }) => rem($marginBottom)};
  max-width: ${({ $isSmall }) => ($isSmall ? rem(84) : '100%')};
  width: 100%;
`;
